
import { Component, Prop, Vue } from 'vue-property-decorator'
import { SelectItem } from '@/models/SelectItem'

/**
 * セレクト部品の基底コンポーネント
 */
@Component
export default class SelectBase extends Vue {
  /** オプション情報 */
  @Prop()
  private options!: SelectItem[]

  /** オプションの初期選択値 */
  @Prop()
  private optionDefault?: string | undefined

  /** disabled制御 */
  @Prop({ default: false })
  private disabled!: boolean

  /** 選択された値 */
  public selectedValue: string = ''

  /**
   * 初期処理
   */
  private mounted(): void {
    if (this.optionDefault) {
      this.selectedValue = this.optionDefault
    }
  }

  /**
   * 現在の選択値を設定
   *   選択肢の変更時にv-modelを直接書き換える
   *
   * @param value 選択値指定
   */
  public setCurrentValue(value: string): void {
    this.selectedValue = value
  }

  /**
   * チェンジイベントの発火を親コンポーネントに通知する
   *
   * @param event イベントオブジェクト
   */
  private changeEvent(event: Event): void {
    this.$emit('change', event)
  }
}
